import styled from '@emotion/styled';
import { spacing, breakpoints } from 'theme';

export const OppHeader = styled.div({
  '& > * + *': {
    marginTop: spacing[12],
  },
});

export const InnerContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  gap: spacing[8],

  [`${breakpoints.mobile}`]: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',

    '& > *': {
      flex: '0 1 fit-content',
    },

    '& > button': {
      width: 'fit-content',
    },
  },
});
